
const dark = {
    logoColor:"#ffffff",
    accent : "#1495f3",
    accentHover:"#1496f31f",
    accentDisabled:"#1495f380",
    accentMute:"#1595f30f",
    iconColor:"#ffffff",
    iconColorActive:"#1495f3",
    bgColor:"#151f2b",
    modalOverlayBg:"#9fc8e61f",
    borderColorHigh:"#243241",
    heading:"#ffffff",
    iconMain:"#ffffff",
    feedOutline:"#37444d",
    feedIcon:"rgb(136, 153, 166)",
    text:"#dfe3e6",
    textMuted:"#80919e",
    linkColor:"rgb(27, 149, 224)",

    widgetSearchBg:"#243241",
    widgetBg:"#172634",
    modalShadow:"#74b5e438",
    feedHoverBg:"#1c2733",


}

const light = {
    logoColor:"#1495f3",
    accent : "#1495f3",
    accentHover:"#1496f31f",
    accentDisabled:"#1495f380",
    accentMute:"#1595f30f",
    iconColor:"#ffffff",
    iconColorActive:"#1495f3",
    bgColor:"#ffffff",
    modalOverlayBg:"#9fc8e61f",
    borderColorHigh:"#243241",
    heading:"#ffffff",
    iconMain:"#1495f3",
    feedOutline:"#eeeeee",
    feedIcon:"rgb(136, 153, 166)",
    text:"#000000",
    textMuted:"#121212",
    linkColor:"rgb(27, 149, 224)",

    widgetSearchBg:"#ebeef0",
    widgetBg:"#ffffff",
    modalShadow:"#74b5e438",
    feedHoverBg:"#f0fff06b",


}

const dim = {
    logoColor:"#ffffff",
    accent : "#1495f3",
    accentHover:"#1496f31f",
    accentDisabled:"#1495f380",
    accentMute:"#1595f30f",
    iconColor:"#ffffff",
    iconColorActive:"#1495f3",
    bgColor:"#151f2b",
    modalOverlayBg:"#9fc8e61f",
    borderColorHigh:"#243241",
    heading:"#ffffff",
    iconMain:"#ffffff",
    feedOutline:"#37444d",
    feedIcon:"rgb(136, 153, 166)",
    text:"#dfe3e6",
    textMuted:"#80919e",
    linkColor:"rgb(27, 149, 224)",

    widgetSearchBg:"#243241",
    widgetBg:"#172634",
    modalShadow:"#74b5e438",
    feedHoverBg:"#cccccc",


}




export  const Theme = {dark,light,dim} 